import repositories from '@/repositories'
import getMocks from '@/mocks'

const mockMode = process.env.VUE_APP_MOCK_MODE === '1'

export default {
  async create() {
    const mocks = await getMocks()

    return {
      get(name: keyof typeof repositories) {
        return mockMode ? mocks[name] : repositories[name]
      },
    }
  },
}
